import React from 'react';
import {ExternalLinksLegacyStrategy} from "./external-links-legacy.strategy";
import {MarketingParams} from "../../../../common/interfaces/marketing-params.interface";
import {IExternalLinksHandlersFactory} from "../handlers-factory/external-links-handlers-factory.interface";
import {IOpenMyAccountOptions} from "../handlers/my-account/my-account.external-link-handler.interface";
import {
    IOpenGameLimitsOptions,
    IOpenOmgOptions,
    IOpenPendingLoginOptions,
    IOpenPendingPlayOptions,
    OpenLinkParams,
    OpenRichPageOptions
} from "../external-links.service.interface";
import {IOpenRegistrationOptions} from "../handlers/registration/registration.external-link-handler.interface";
import {OpenCashierOptions} from "../../../../common/interfaces/cashier.service.interface";
import {GNWP_SOURCES} from "../../../../sdk/src/components/external_links/external_links_consts";
import {PRIORITY_LEVEL} from "../../../../sdk/src/services/overlay_manager/overlay_manager_levels";
import {ExternalLinksZIndexes} from "../external-links-z-indexes";
import {CHANNEL_SOURCE} from "../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core";

export class ExternalLinksModernStrategy extends ExternalLinksLegacyStrategy {

    private get _handlers(): IExternalLinksHandlersFactory {
        return this.services.regulation.current.externalLinks;
    }


    async openMyAccount(options?: IOpenMyAccountOptions, marketingParams?: MarketingParams): Promise<void> {
        await this._handlers.myAccount.openMyAccount(options);
    }

    async openCashier(options?: OpenCashierOptions): Promise<void> {
        await this._handlers.cashier.openCashier(options);
    }

    async openMembership(options?: IOpenRegistrationOptions): Promise<void> {
        await this._handlers.registration.openRegistration(options);
    }

    openLink(params: OpenLinkParams, marketingParams?: MarketingParams, useCallbackURL: boolean = false): Promise<any> {
        if(params.source === GNWP_SOURCES.MEMBERSHIP) {
            return this.openMembership({
                ...params?.options,
                marketingParams: marketingParams
            });
        } else if(params.source === GNWP_SOURCES.CASHIER) {
            return this.services.cashier.openCashier({
                sessionType: params.options?.sessionType,
                PromCode: params.options?.PromCode,
                channel: {
                    source: CHANNEL_SOURCE.casinoClient,
                    area: AreaType.NavigationMenu
                }
            });
        } else if(params.source === GNWP_SOURCES.MY_ACCOUNT) {
            return this.openMyAccount(params.options);
        } else if(params.source === GNWP_SOURCES.OMG) {
            return this.openOMG({
                openedWithinGame: params.options.openedWithinGame,
                messages: params.options.Messages,
                zIndex: params.priorityLevel === PRIORITY_LEVEL.OMG ? ExternalLinksZIndexes.Omg : ExternalLinksZIndexes.OmgBehindTheGame,
            })
        } else if(params.source === GNWP_SOURCES.FORGOT_USERNAME) {
            return this.openForgotUserName();
        } else if(params.source === GNWP_SOURCES.FORGOT_PASSWORD) {
            return this.openForgotPassword();
        } else if(params.source === GNWP_SOURCES.PENDING_LOGIN) {
            return this.openPendingLogin({
                token: params.options?.token
            });
        } else if(params.source === GNWP_SOURCES.PENDING_PLAY) {
            return this.openPendingPlay({
                token: params.options?.token
            });
        } else if(params.source === GNWP_SOURCES.DOCUMENT_UPLOAD) {
            return this.openUploadDocument();
        } else if(params.source === GNWP_SOURCES.CONTACT_US) {
            return this.openContactUs();
        } else if(params.source === GNWP_SOURCES.HELP) {
            return this.openHelpPage();
        }

        return super.openLink(params, marketingParams, useCallbackURL);
    }

    openOMG(options: IOpenOmgOptions): Promise<void> {
        return this._handlers.omg.openOmg(options);
    }

    openForgotPassword(): Promise<void> {
        return this._handlers.forgotPassword.openForgotPassword();
    }

    openForgotUserName(): Promise<void> {
        return this._handlers.forgotUserName.openForgotUserName();
    }

    openPendingLogin(options: IOpenPendingLoginOptions): Promise<void> {
        return this._handlers.pendingLogin.openPendingLogin(options);
    }

    openPendingPlay(options: IOpenPendingPlayOptions): Promise<void> {
        return this._handlers.pendingPlay.openPendingPlay(options);
    }

    openUploadDocument(): Promise<void> {
        return this._handlers.uploadDocuments.openUploadDocuments();
    }

    openGameLimits(options:IOpenGameLimitsOptions): Promise<void>{
        return this._handlers.gameLimits.openGameLimits(options);
    }

    openContactUs(): Promise<void> {
        return this._handlers.contactUs.openContactUs();
    }

    openRichPage(options: OpenRichPageOptions): Promise<void> {
        return this._handlers.rich.openRichPage(options);
    }

    renderRichPageContent(): Promise<React.ReactElement> {
        return this._handlers.rich.renderRichPageContent();
    }

    openHelpPage(): Promise<void> {
        return this._handlers.help.openHelpPage();
    }

}